import { render, staticRenderFns } from "./VueDeckGL.vue?vue&type=template&id=5ea4a123&scoped=true&"
import script from "./VueDeckGL.vue?vue&type=script&lang=js&"
export * from "./VueDeckGL.vue?vue&type=script&lang=js&"
import style0 from "./VueDeckGL.vue?vue&type=style&index=0&id=5ea4a123&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea4a123",
  null
  
)

export default component.exports